import React from 'react'

import CoreNumberField from 'modules/core/components/NumberField'

type NumberFieldProps = React.ComponentProps<typeof CoreNumberField>

const NumberField = ({ max, ...props }: NumberFieldProps) => (
  <CoreNumberField
    {...props}
    onKeyDown={(e: React.KeyboardEvent) => {
      //allow some special keys
      if (
        e.ctrlKey ||
        e.metaKey ||
        ['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab', 'Home', 'End'].includes(e.key)
      ) {
        return
      }

      //only allow digits
      const isDigit = /^[0-9]$/.test(e.key)
      if (!isDigit) {
        e.preventDefault()
        return
      }

      // validate max value
      if (max) {
        // eslint-disable-next-line no-type-assertion/no-type-assertion
        const target = e.target as HTMLInputElement
        const value = target.value
        const newValue =
          value.substring(0, Number(target.selectionStart)) +
          e.key +
          value.substring(Number(target.selectionEnd))
        if (Number(newValue) > max) {
          e.preventDefault()
          return
        }
      }
    }}
  />
)

export default NumberField
